import React, {useCallback} from 'react';
import {useNavigate} from 'react-router-dom';
import DialogApiRequestStatus from '../../../components/dialogs/DialogApiRequestStatus';

export type OnboardingSuccessVariant = 'submitted' | 'accounts-created';

const successMessageByVariant: Record<OnboardingSuccessVariant, string> = {
  submitted: 'Your request submitted successfully!',
  'accounts-created': 'Account Created Successfully',
};

export const resolveOnboardingSuccessVariant = (
  status?: string,
): OnboardingSuccessVariant | null => {
  if (status === 'submitted' || status === 'specialist_review') {
    return 'submitted';
  }

  if (status === 'accounts_created' || status === 'completed') {
    return 'accounts-created';
  }

  return null;
};

interface OnboardingSuccessDialogProps {
  variant: OnboardingSuccessVariant;
  onClose?: () => void;
}

const OnboardingSuccessDialog: React.FC<OnboardingSuccessDialogProps> = ({
  variant,
  onClose,
}) => {
  const navigate = useNavigate();

  const handleClose = useCallback(() => {
    onClose?.();
    navigate('/dashboard', {replace: true});
  }, [navigate, onClose]);

  return (
    <DialogApiRequestStatus
      apiState={{
        status: 'success',
        error: null,
        message: successMessageByVariant[variant],
      }}
      onClose={handleClose}
    />
  );
};

export default OnboardingSuccessDialog;
